module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "theme": "dark",
      "default-active": _vm.active,
      "title": _vm.$route.path,
      "default-openeds": _vm.default_openeds,
      "background-color": "#304156",
      "text-color": "#fff",
      "active-text-color": "#1890ff"
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bf511080", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf511080"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = 321
// module chunks = 88